/*
  ds-preorder-notify.js
  Sends "Not ready to order? We'll email you when it lands" requests from the pre-order box to the HubSpot
  Help Desk (same form as Submit a Request: reason Product, sub-reason Stock and lead time).
  If HubSpot can't be reached, the normal Shopify contact form posts instead, so nothing is lost.
  Loaded from snippets/cart-summary.liquid (rendered on every page) so ds-preorder.js does not need changing.
*/
(function () {
  if (window.__dspoNotifyHook) return;
  window.__dspoNotifyHook = true;
  var PORTAL = '147772373';
  var FORM = 'a1536915-7647-4e1d-a1d5-77644b8b2b66';

  document.addEventListener('submit', function (e) {
    var nf = e.target;
    if (!nf || !nf.classList || !nf.classList.contains('dspo__notify')) return;
    if (nf.__dspoFallback || !window.fetch) return; // let the Shopify form post
    var emailEl = nf.querySelector('input[type="email"]');
    if (!emailEl || !emailEl.value) return;
    e.preventDefault();

    var root = nf.closest('[data-dspo]') || document;
    var variantEl = nf.querySelector('[data-dspo-notify-variant]');
    var variantLabel = variantEl ? variantEl.value : '';
    var m = variantLabel.match(/\(([^()]+)\)\s*$/);
    var sku = m ? m[1].trim() : '';
    var option = variantLabel.replace(/\s*\([^()]*\)\s*$/, '').trim();
    var title = document.title.split('|')[0].trim();
    var subEl = root.querySelector('[data-dspo-sub]');
    var despatch = subEl ? subEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var details = [
      'BACK IN STOCK REQUEST from the product page. Please email this customer when it lands.',
      'Product: ' + title,
      option && option !== 'Default Title' ? 'Option: ' + option : '',
      'SKU: ' + sku,
      despatch ? 'Shown to customer: ' + despatch : '',
      'Page: ' + window.location.href
    ].filter(Boolean).join('\n');
    var c = document.cookie.match('(^|;)\\s*hubspotutk\\s*=\\s*([^;]+)');
    var payload = {
      fields: [
        { name: 'email', value: emailEl.value.trim() },
        { name: 'cc_request_reason', value: 'product' },
        { name: 'cc_request_subreason', value: 'advice_stock_lead_time' },
        { name: 'cc_product_code', value: sku },
        { name: 'cc_details', value: details },
        { name: 'cc_enquiry_reference', value: 'BIS-' + sku + '-' + Math.floor(100000 + Math.random() * 900000) }
      ],
      context: { hutk: c ? c.pop() : undefined, pageUri: window.location.href, pageName: 'Back in stock request: ' + title }
    };
    var btn = nf.querySelector('button[type="submit"]');
    var btnText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

    fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL + '/' + FORM, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error(res.status);
      var row = nf.querySelector('.dspo__notify-row'), lbl = nf.querySelector('.dspo__notify-label');
      if (row) row.hidden = true;
      if (lbl) lbl.hidden = true;
      var done = document.createElement('p');
      done.className = 'dspo__notify-done';
      done.setAttribute('role', 'status');
      done.textContent = 'Thanks, we’ll email you as soon as it lands.';
      nf.appendChild(done);
    }).catch(function () {
      nf.__dspoFallback = true;
      if (btn) { btn.disabled = false; btn.textContent = btnText; }
      if (nf.requestSubmit) nf.requestSubmit(); else nf.submit();
    });
  }, true);
})();
